import { createDiscreteApi } from 'naive-ui';

export const naiveDiscrete = createDiscreteApi(['message', 'notification', 'loadingBar', 'dialog']);
